<template lang="pug">
  #app
    router-view
    footer.mt-0.pt-5.footer(style='background: #F7F7F7; color: white')
      b-container(fluid)
        b-row.pb-5
          b-col(cols=4 style="border-right: solid 1px black !important;" ).pl-5
            .footerText.pr-5
              p ABOUT US <br><br>
              | Carrer Emili Grahit, 101, Edifici H2O<br>
              | Parc Científic i Tecnològic de la Universitat de Girona
          b-col(cols=4)
            a.pl-5.float-left(href='https://www.icra.cat/' target='_blank')
              img.pb-4(src="../public/images/logoIcra.svg" )
          b-col(cols=4)
            b-row.align-items-center
              b-col
                a.pl-5.float-left(href='https://www.nceas.ucsb.edu/' target='_blank')
                  img.pb-4(src="../public/images/Snapp-Logo-Color.png" height="100")
              b-col
                a.pl-5.float-left(href='https://cerca.cat/' target='_blank')
                  img.pb-4(src="../public/images/logoCerca.svg" )
            b-row.align-items-center
              b-col
                a.pl-5.float-left(href='https://www.udg.edu/' target='_blank')
                  img.pb-4(src="../public/images/logoUdg.svg" )
              b-col
                a.pl-5.float-left(href='https://www.nature.org/' target='_blank')
                  img.pb-4(src="../public/images/logoNature.svg" )
        b-row.pb-2
          b-col.pl-5
            span.footerTextLittle This work resulted from the Science for Nature and People Partnership (SNAPP) "Water Sanitation & Nature" Working Group. SNAPP is a partnership of The Nature Conservancy, Wildlife Conservation Society and the National Center for Ecological Analysis and Synthesis at the University of California, Santa Barbara
        b-row(style="height: 43px; background: #5E686D;").align-items-center
          b-col.pl-5
            p.pr-5.m-0 © 2021 SNAPP
              a.pl-5.pr-2(href="../privacy" style="color: white") Privacy policy
              span |
              a.pl-2(href="../privacy" style="color: white") Cookie policy
          b-col.pr-5
            p.float-right.pr-5.m-0
              a(href="../viti.cat" style="color: white") Web design viti.cat


</template>

<script>

export default
  {
    data(){
      return {
        logoIcra: require("@/assets/logo_icra.png"),
        logoUdg: require("@/assets/logo_udg.png"),
        logoCerca: require("@/assets/logo_cerca.jpg"),
    }
  }
}
</script>

<style scoped>
  .footerText{
    /* text */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */


    color: #000000;
  }

  .footerTextLittle{
    color: grey;
    font-style: italic;
    font-size: 0.7vw;
  }


</style>

<style>
  .littleText{
    font-size: 10px;
  }
  .mediumText{
    font-size: 15px;
  }
</style>
